export function entityName(definitionId: string): string {
  const raw = definitionId.split(".").pop() ?? definitionId;
  return raw.charAt(0).toUpperCase() + raw.slice(1).replace(/-/g, " ");
}
